import {Link} from 'react-router-dom';
import {useCookieConsent} from '../contexts/CookieConsentContext';

const Footer = () => {
    const {openConsentSettings} = useCookieConsent();

    return (
        <footer className="text-gray-700 text-sm mt-8">
            {/* Vonal */}
            <div className="container mx-auto">
                <div className="border-t border-pink-200 my-5"></div>
            </div>

            {/* Tartalom */}
            <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-6 py-6">
                {/* Kontakt */}
                <div>
                    <h5 className="font-bold mb-3">Kontakt</h5>
                    <ul className="space-y-2">
                        <li>0175/4454264</li>
                        <li>info@pegasuspole.de</li>
                        <li>Luxemburgerstraße 148, 54294 Trier</li>
                    </ul>
                </div>

                {/* Menülinkek */}
                <div>
                    <ul className="space-y-2">
                        <li><a href={`${process.env.REACT_APP_BASE_SITE_URL}/impressum`} className="hover:underline">Impressum</a></li>
                        <li><a href={`${process.env.REACT_APP_BASE_SITE_URL}/datenschutzerklaerung`} className="hover:underline">Datenschutz</a></li>
                        <li><a href={`${process.env.REACT_APP_BASE_SITE_URL}/allgemeine-geschaeftsbedingungen`} className="hover:underline">AGB</a></li>
                        <li><a href={`${process.env.REACT_APP_BASE_SITE_URL}/widerrufsbelehrung`} className="hover:underline">Widerrufsbelehrung</a></li>
                        <li><Link to="/vertrag-widerrufen" className="hover:underline">Vertrag widerrufen</Link></li>
                        <li><a href={`${process.env.REACT_APP_BASE_SITE_URL}/nutzungsbedingungen-pin-code`} className="hover:underline">PIN-Code-Bedingungen</a></li>
                        <li><a href={`${process.env.REACT_APP_BASE_SITE_URL}/haufig-gestellte-fragen`} className="hover:underline">FAQ</a></li>
                        <li><button onClick={openConsentSettings} className="hover:underline">Cookie-Einstellungen</button></li>
                    </ul>
                </div>

                {/* Social Media */}
                <div>
                    <ul className="space-y-2">
                        <li><a href="https://www.facebook.com/pegasuspoletrier" className="hover:underline" target="_blank" rel="noreferrer">Facebook</a></li>
                        <li><a href="https://www.instagram.com/pegasuspoletrier" className="hover:underline" target="_blank" rel="noreferrer">Instagram</a></li>
                        <li><a href="https://www.tiktok.com/@pegasuspoletrier" className="hover:underline" target="_blank" rel="noreferrer">TikTok</a></li>
                    </ul>
                </div>
            </div>

            {/* Copyright */}
            <div className="text-center text-gray-500 py-4">
                © Copyright Pegasus Pole
            </div>
        </footer>
    );
};

export default Footer;
